<script lang="ts">
  import Brand from "@/components/Brand.svelte";
</script>

<main class="loading-screen" aria-live="polite">
  <Brand />
  <span class="loading-orbit" aria-hidden="true"></span>
  <p>Синхронизация с орбитой</p>
</main>
